import checkMarkIcon from 'assets/images/check.svg';
import { rem, size } from 'polished';
import styled from 'styled-components';

export const FeatureList = styled.ul`
  margin: ${rem(32)} 0;
  padding: 0;

  * + * {
    margin-top: ${rem(20)};
  }
`;

export const FeatureListItem = styled.li`
  display: flex;
  align-items: center;
  font-size: ${rem(16)};
  line-height: 1.4;
  text-align: left;
  list-style: none;

  &::before {
    ${size(rem(20))}

    display: block;
    flex-shrink: 0;
    margin-right: 1em;
    background-image: url(${checkMarkIcon});
    background-size: cover;
    content: '';
  }
`;
